export default __webpack_public_path__ + "static/media/boss_tartaglia_shadow.76b81bcc.png";